module.exports = __webpack_public_path__ + "static/media/Kronos.de4bac65.svg";